export enum PaymentOptions {
  'luki-client' = 'luki-client',
  'luki-new-client' = 'luki-new-client',
  'banking-transfer' = 'banking-transfer',
  'yappy' = 'yappy',
}
